module.exports = __webpack_public_path__ + "img/empty.10b78339.svg";